import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Loans from '@/pages/Loans.vue'
import LoansView from '@/pages/Loans/View.vue'
import LoansDetail from '@/pages/Loans/Detail.vue'
import LoansEdit from '@/pages/Loans/Edit.vue'

import Investment from '@/pages/Investment.vue'
import InvestmentView from '@/pages/Investment/View.vue'
import InvestmentDetail from '@/pages/Investment/Detail.vue'
import InvestmentEdit from '@/pages/Investment/Edit.vue'


import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'

import Profile from '@/pages/Profile.vue'
import ChangePassword from '@/pages/ChangePassword.vue'
import Logout from '@/pages/Logout.vue'


import Clients from '@/pages/Clients.vue'
import ClientsView from '@/pages/Clients/View.vue'
import ClientsDetail from '@/pages/Clients/Detail.vue'
import ClientsEdit from '@/pages/Clients/Edit.vue'

import Investors from '@/pages/Investors.vue'
import InvestorsView from '@/pages/Investors/View.vue'
import InvestorsDetail from '@/pages/Investors/Detail.vue'
import InvestorsEdit from '@/pages/Investors/Edit.vue'

import Transactions from '@/pages/Transactions.vue'
import TransactionsView from '@/pages/Transactions/View.vue'

import Stats from '@/pages/Stats.vue'
import StatsView from '@/pages/Stats/View.vue'

import PrintLoan from '@/pages/PrintLoan.vue'
import PrintLoanContract from '@/pages/PrintLoanContract.vue'

import Calendar from '@/pages/Calendar.vue'
import InvestmentCalendar from '@/pages/InvestmentCalendar.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'

import ClientLoans from '@/pages/ClientLoans.vue'
import ClientLoansView from '@/pages/ClientLoans/View.vue'
import ClientLoansDetail from '@/pages/ClientLoans/Detail.vue'
import ClientLoansEdit from '@/pages/ClientLoans/Edit.vue'
import ClientLoansNew from '@/pages/ClientLoans/New.vue'


const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						name: "Settings",
						component: SettingsView
					}
				]
			},
			{
				path: 'loans',
				component: Loans,
				children: [
					{
						path: '',
						name: "Loans Management",
						component: LoansView
					},
					{
						path: 'detail/:hash_id',
						name: 'Loans Management',
						component: LoansDetail
					},
					{
						path: 'edit/:id',
						name: 'ផ្ទាំងកែប្រែព័ត៌មានក្រុមហ៊ុន',
						component: LoansEdit
					}
				]
			},
			{
				path: 'investment',
				component: Investment,
				children: [
					{
						path: '',
						name: "Investment Management",
						component: InvestmentView
					},
					{
						path: 'detail/:hash_id',
						name: 'Investment Management',
						component: InvestmentDetail
					},
					{
						path: 'edit/:id',
						name: 'ផ្ទាំងកែប្រែព័ត៌មានក្រុមហ៊ុន',
						component: InvestmentEdit
					}
				]
			},
			{
				path: 'my_loans',
				component: ClientLoans,
				children: [
					{
						path: '',
						name: "ផ្ទាំងគ្រប់គ្រងការកម្ជី",
						component: ClientLoansView
					},
					{
						path: 'detail/:hash_id',
						name: 'ផ្ទាំងគ្រប់គ្រងការកម្ជី',
						component: ClientLoansDetail
					},
					{
						path: 'edit/:id',
						name: 'ផ្ទាំងកែប្រែព័ត៌មានក្រុមហ៊ុន',
						component: ClientLoansEdit
					}
				]
			},
			{
				path: 'clients',
				component: Clients,
				children: [
					{
						path: '',
						name: "Clients Management",
						component: ClientsView
					},
					{
						path: 'edit/:hash_id',
						name: "Clients Management",
						component: ClientsEdit
					},
					{
						path: 'detail/:hash_id',
						name: "Clients Management",
						component: ClientsDetail
					}
				]
			},
			{
				path: 'investors',
				component: Investors,
				children: [
					{
						path: '',
						name: "Investors Management",
						component: InvestorsView
					},
					{
						path: 'edit/:hash_id',
						name: "Investors Management",
						component: InvestorsEdit
					},
					{
						path: 'detail/:hash_id',
						name: "Investors Management",
						component: InvestorsDetail
					}
				]
			},
			{
				path: 'transactions',
				component: Transactions,
				children: [
					{
						path: '',
						name: "Transactions Management",
						component: TransactionsView
					}
				]
			},
			{
				path: 'calendar',
				name: "Loan Calendar Management",
				component: Calendar,
			},
			{
				path: 'investment_calendar',
				name: "Investment Calendar Management",
				component: InvestmentCalendar,
			},
			{
				path: 'stats',
				component: Stats,
				children: [
					{
						path: '',
						name: "ទិន្នន័យស្ថិតិ",
						component: StatsView
					}
				]
			},
			{
				path: 'profile',
				name: "ព័ត៌មានរបស់ខ្ញុំ",
				component: Profile,
			},
			{
				path: 'logout',
				name: "ចាកចេញ",
				component: Logout,
			},
			{
				path: 'change_password',
				name: "ផ្លាស់ប្តូរពាក្យសំងាត់",
				component: ChangePassword,
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						name: "Administrators",
						component: AdministratorsView
					},
					{
						path: 'edit/:id',
						name: 'Administrators',
						component: AdministratorsEdit
					}
				]
			}
		]
	},
	{
		path: '/print_loan/:hash_id',
		name: "Print Loan",
		component: PrintLoan,
	},
	{
		path: '/print_loan_contract/:hash_id',
		name: "Print Loan Contract",
		component: PrintLoanContract,
	},
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js